exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-28bff374]{margin-bottom:27px;padding-bottom:8px;border-bottom:1px solid #cfd4d8}.info__data[data-v-28bff374]{margin-bottom:6px;font-family:Open Sans,sans-serif;font-size:14px;line-height:1.4;font-weight:700;color:rgba(0,0,0,.85)}.info__data span[data-v-28bff374]{font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28bff374","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orders/OrderInfo.vue
// module id = efbfce7736a8ddda9f18
// module chunks = 0